import { get_token, get_user_details} from "@/router";
import Swal from 'sweetalert2';

export default {
    name: 'FolderView',
    props: {
        folder: Object,
        portal_admin: {
            type: Boolean,
            default: false
        },
        current_portal_permissions: {
            type: Object,
            default: () => ({})
        }
    },
    mounted(){
      this.user_details = get_user_details();
          this.token_exists = get_token();
          this.user_id = this.get_user_id();
      this.fetch_document_warehouse_folders();

    },
    data() {
      return ({
        folders: [],
        currentFolderName: '',
        selectedSubfolder: null,
        isLoading: false,
        permission_types: [],
        permission_map: {},
        selected_folder: {},
        folder_permissions: [],
        members: [],
        user_details: {},
        user_id: null,
        
      });   
    },
    watch: {
      folderId: {
        immediate: true,
        handler(newId) {
          if (newId !== undefined && newId !== null) {
            this.fetch_document_warehouse_folders(newId);
          }
        }
      }
    },
    computed: {

      can_delete() {
      return this.current_portal_permissions?.delete === true || this.portal_admin === true;
    },
      filteredPortalMembers() {
        if (!this.searchQuery) return this.folder_permissions;
    
        const query = this.searchQuery.toLowerCase();
    
        return this.folder_permissions.filter(user => {
          const firstName = user.portal_access.user.first_name?.toLowerCase() || '';
          const lastName = user.portal_access.user.last_name?.toLowerCase() || '';
          const email = user.portal_access.user.email?.toLowerCase() || '';
          return firstName.includes(query) || lastName.includes(query) || email.includes(query);
        });
      }
    },
    
    methods: {
      getToken() {
        return get_token();
      },
      get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
      openFolder() {
        this.$emit('open-folder', this.folder);
      }
      ,
      fetch_document_warehouse_folders(newId) {
        if (!newId) {
          console.warn("Invalid folder ID", newId);
          return;
        }

        const payload = {
          portal_id: this.$route.params.portal_id,
          parent_folder_id: newId
        }

        const params = new URLSearchParams(payload).toString();
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/?${params}`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (response) => {
            this.folders = response.data;
            // Optionally update the folder name if available
            if (response.data.length > 0) {
              this.currentFolderName = response.data[0].parent_folder_name || '';
            } else {
              this.currentFolderName = 'Empty Folder';
            }

            setTimeout(() => {

              this.loading = false;
            }, 1000);
          },
          error: (xhr) => {
            let errorMessage = 'An unexpected error occurred.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },
      openSubfolder(folder) {
        this.selectedSubfolder = folder;
      },
      delete_folder(folder_id) {
        const payload = {
          folder_id: folder_id,
        };

        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel',
          reverseButtons: true,
          position: 'bottom-end',
          toast: true
        }).then((result) => {
          if (!result.isConfirmed) {
            return;
          }

          this.isLoading = true;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder/`,
            method: 'POST',
            headers: {
              Authorization: `Token ${this.getToken()}`,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify(payload),
            success: (data) => {
              if (data.status === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Folder deleted.',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  Swal.close();
                  this.$emit('folder-deleted', folder_id);
                });
              }
            },
            error: (xhr) => {
              let errorMessage = 'An unexpected error occurred.';
              if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMessage = xhr.responseJSON.message;
              }
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
            },
            complete: () => {
              this.isLoading = false;
            },
          });
        });
      },

      edit_folder(folder) {
        this.$emit('edit-folder', folder);
      },

      get_permissions_types(callback) {
        this.token_exists = get_token();

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_permissions/`,
          method: "GET",
          headers: this.token_exists
            ? {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
              }
            : {},
          success: (response) => {
            this.permission_types = response.permission_types;
            this.permission_map = {};
            this.permission_types.forEach(perm => {
              this.permission_map[perm.name.toLowerCase()] = perm.id;
            });
      
            if (callback) callback(); // <--- call after map is ready
          },
          complete: () => {
            this.isLoading = false;
          },
        });

      },

      get_folder_permissions(folder_id) {
        this.token_exists = get_token();
      
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_permissions/?folder_id=${folder_id}`,
          method: "GET",
          headers: this.token_exists
            ? {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
              }
            : {},
          success: (response) => {
            const raw_permissions = response.folder_permissions;
            const grouped = new Map();
      
            raw_permissions.forEach(perm => {
              const user_id = perm.portal_access.id;
      
              // Initialize user object if not already in the map
              if (!grouped.has(user_id)) {
                grouped.set(user_id, {
                  portal_access: {
                    id: user_id,
                    user: {
                      id: perm.portal_access.user?.id || perm.portal_access.id,
                      first_name: perm.portal_access.first_name || "",
                      last_name: perm.portal_access.last_name || "",
                      email: perm.portal_access.email || ""
                    }
                  },
                  view: false,
                  edit: false,
                  delete: false,
                  create: false,
                  is_owner: perm.is_owner || false
                });
              }
      
              // ✅ Safe assignment via explicit checks
              const userPermissions = grouped.get(user_id);
              switch ((perm.permission?.name || "").toLowerCase()) {
                case "view":
                  userPermissions.view = true;
                  break;
                case "edit":
                  userPermissions.edit = true;
                  break;
                case "delete":
                  userPermissions.delete = true;
                  break;
                case "create":
                  userPermissions.create = true;
                  break;
                default:
                  // ignore unknown permissions
                  break;
              }
            });
      
            this.folder_permissions = Array.from(grouped.values());
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },

      fetch_portal_members(callback) {
        this.isLoading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
          method: "GET",
          data: { portal_id: this.$route.params.portal_id },
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          success: (response) => {
            if (response.status === "success") {
              this.members = response.data.members;
              // Map members to folder_permissions template
              this.folder_permissions = this.members.map(member => ({
                portal_access: { id: member.id, user: member.user },
                view: false,
                create: false,
                edit: false,
                delete: false,
                is_owner: false
              }));
            }
            if (callback) callback();
          },
          error: (xhr) => {
            if (xhr.status === 403) {
              this.$router.push("/");
              Swal.fire({
                icon: "error",
                title: "Access Denied",
                text: "You are not authorized to be in this portal.",
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
              });
            }
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },
      manage_folder_permissions(folder) {
        if (!folder || !folder.id) {
          Swal.fire({
            title: "Error",
            text: "Invalid folder selected.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          return;
        }
      
        // Update the selected folder every time
        this.selected_folder = folder;
      
        // Reset old permissions
        this.folder_permissions = [];
      
        // Fetch types & members
        this.get_permissions_types(() => {
          this.fetch_portal_members(() => {
            this.get_folder_permissions(folder.id);
      
            // Show modal (close first if already open)
            $(`#manage_folder_permissions_modal${this.selected_folder.id}`).modal('hide');
            setTimeout(() => {
              $(`#manage_folder_permissions_modal${this.selected_folder.id}`).modal('show');
            }, 100);
          });
        });
      },
      
      
      

      save_folder_permissions() {
        
        if (!this.selected_folder?.id) {
          Swal.fire({
            title: "Error",
            text: "No folder selected.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          return;
        }

      
        const folderId = this.selected_folder.id;
      
        const payloads = this.folder_permissions
          .filter(user => !user.is_owner)
          .map(user => {
            const permissionTypeIds = [];
            if (user.view) permissionTypeIds.push(this.permission_map.view);
            if (user.edit) permissionTypeIds.push(this.permission_map.edit);
            if (user.delete) permissionTypeIds.push(this.permission_map.delete);
            if (user.create) permissionTypeIds.push(this.permission_map.create);
      
            if (permissionTypeIds.length === 0) return null;
      
            return {
              folder_id: folderId,
              portal_member_ids: [user.portal_access.user.id],
              permission_type_ids: permissionTypeIds
            };
          })
          .filter(p => p !== null);
      
        if (payloads.length === 0) {
          Swal.fire({
            title: "Info",
            text: "No permissions selected for any users.",
            icon: "info",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          return;
        }
      
        payloads.forEach(payload => {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/set_folder_permissions/`,
            method: "POST",
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify(payload),
            error: (xhr) => console.error(`Failed to save for ${payload.portal_member_ids[0]}`, xhr.responseJSON)
          });
        });
      
        Swal.fire({
          title: "Success",
          text: "Permissions Set Successfully",
          icon: "success",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        $(`#manage_folder_permissions_modal${this.selected_folder.id}`).modal('hide');
      },
      
      
      
      searchUsers() {
        const payload = {
          portal_id: this.$route.params.portal_id,
          search_query: this.searchQuery
        };
      
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
          method: "GET",
          data: payload,
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          success: (response) => {
            // Map backend members to your folder_permissions structure
            this.folder_permissions = response.data.members.map(member => ({
              portal_access: { user: member.user, id: member.id }, // wrap user object
              view: false,
              create: false,
              edit: false,
              delete: false,
              is_owner: false
            }));
          },
          error: (xhr) => {
            console.error(xhr.responseJSON);
          }
        });

      }
    }
  };
